import type { IConfReportes } from "@/modules/Reportes/interfaces"
import { historiaGraficaService, reporteService } from "@/services"
import type { ICitaTechnologiasSalud, IGraficaItem } from "../interfaces"
import type { IConfPersonasPaciente } from "@/modules/Administracion/interfaces"
import { Chart, type BubbleDataPoint, type ChartTypeRegistry, type Point } from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom'
import { createGrafic } from '@/modules/Core/usings/graficas'
import type { IComponentGraficasItems } from "@/modules/Configuracion/interfaces/IFormComponent"
import type { IConfGraficas, IConfGraficaspercentiles } from "@/modules/Configuracion/interfaces"

Chart.register(zoomPlugin)
const getReporte = async (nombreReporte: string): Promise<IConfReportes[]> => {
  const { data } = await reporteService.list({ coreNombre: nombreReporte })
  const reporte = data.body
  return reporte
}
const getDataSource = async (sexo: string, edad: number): Promise<IConfGraficas[]> => {
  const { data } = await historiaGraficaService.list({ sexo, edad, withAssociations: true })
  let graficas = data.body
  graficas = graficas.map((item) =>{  return { ...item, percentiles: item.percentiles?.map(itemPercentil => { return { ...itemPercentil, data: JSON.parse(itemPercentil.cogpData)} as IConfGraficaspercentiles} ) }})
  return graficas
}
const execReporte = async (reporte: IConfReportes, parametros: Record<string, string>) => {
  Object.keys(parametros).forEach((item) => {
    if (reporte.parametros !== undefined) {
      const param = reporte.parametros.find(elem => elem.corpNombre == item)
      if (param) param.valor = parametros[item]
    }
  })
  const { data } = await reporteService.execute(reporte)
  return data.body
}
interface grafdibujada { id: string; chart: Chart<keyof ChartTypeRegistry, (number | [number, number] | Point | BubbleDataPoint | null)[], unknown>; }

let graficasDibujadas = [] as grafdibujada[]
export function useGraficas(
  persona: IConfPersonasPaciente,
  technologias?: ICitaTechnologiasSalud[],
  graficasList?: IComponentGraficasItems[] | null) {
  async function getGraficas(){
    const reporte = await getReporte('HISTORICO_DATOS_MEDIDAS')
    if (!reporte) return  { validate: false, validateMessage: 'Error al traer los datos historicos', data: [] }
    let pesos = [] as unknown[]
    if(reporte.length > 0){
      pesos = await execReporte(reporte[0], {
        'P_IDENTIFICACION': persona.copeIdentificacion
      })
    }
    if (!persona.sexo?.comaNombrecorto) {
      return { validate: false, validateMessage: 'paciente con genero no valido', data: [] }
    }
    if (!persona.daisOld) {
      return { validate: false, validateMessage: 'paciente con edad no valida', data: [] }
    }
    const dataSource =  await setGraficas(persona.sexo?.comaNombrecorto, persona.daisOld)
    const graficasData = createGrafic(dataSource, pesos, technologias ? technologias : [], graficasList)
    return { validate: true, validateMessage: '', data: graficasData }
  }
  async function getGraficasBase64(){
    const reporte = await getReporte('HISTORICO_DATOS_MEDIDAS')
    if (!reporte) return  { validate: false, validateMessage: 'Error al traer los datos historicos', data: [] }
    let pesos = [] as unknown[]
    if(reporte.length > 0){
      pesos = await execReporte(reporte[0], {
        'P_IDENTIFICACION': persona.copeIdentificacion
      })
    }
    if (!persona.sexo?.comaNombrecorto) {
      return { validate: false, validateMessage: 'paciente con genero no valido', data: [] }
    }
    if (!persona.daisOld) {
      return { validate: false, validateMessage: 'paciente con edad no valida', data: [] }
    }
    const dataSource =  await setGraficas(persona.sexo?.comaNombrecorto, persona.daisOld)
    const graficasData = createGrafic(dataSource, pesos, technologias ? technologias : [], graficasList)
    const { data } = await historiaGraficaService.getBase64Graphics(graficasData)
    return { validate: true, validateMessage: '', data: data.body }
  }
  async function setGraficas(sexo: string, edad: number) {
      const dataSource =  await getDataSource(sexo, edad)
      localStorage.setItem('graficas', JSON.stringify(dataSource))
      return dataSource
  }
  function dibujarGraficas(graficasData: IGraficaItem[]) {
    for (const grafica of graficasData) {
      const canvas = document.getElementById(grafica.options.id) as HTMLCanvasElement
      const exist = graficasDibujadas.find(e => e.id == grafica.options.id)
      if(exist) {
        exist.chart.destroy()
        graficasDibujadas = graficasDibujadas.filter(e => e.id !== grafica.options.id)
      }
      graficasDibujadas.push({id: grafica.options.id, chart: new Chart(canvas, grafica.options) }) 
    }
  }

  return { getGraficas, dibujarGraficas, getGraficasBase64, setGraficas }
}
